module.exports = __webpack_public_path__ + "kangping/img/4.8c44fc53.png";